import { Archive, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogCancel,
    AlertDialogAction,
} from '@/components/ui/alert-dialog';

export default function AlertDialogDeleteCollaborator({
    open,
    onOpenChange,
    collaborator,
    onConfirm,
    isSubmitting = false,
}) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={isSubmitting ? undefined : onOpenChange}>
            <AlertDialogContent
                className="max-w-[380px] rounded-[20px] p-[24px]"
                onEscapeKeyDown={isSubmitting ? (e) => e.preventDefault() : undefined}
            >
                <AlertDialogHeader className="items-center space-y-0">
                    <div className="w-[56px] h-[56px] rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-[16px]">
                        <Archive className="w-6 h-6 text-destructive" />
                    </div>
                    <AlertDialogTitle className="text-center text-[18px] text-foreground mb-[8px]">
                        {t('subsidiary:archiverLeCollaborateur')}
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-center text-[14px] text-muted-foreground">
                        {t('subsidiary:etesVousSurDeVouloirArchiver')}{' '}
                        <span className="font-semibold text-foreground">{collaborator?.name}</span> {t('subsidiary:leCollaborateurNePourraPlusAccederASon')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="flex-col gap-[12px] sm:flex-col mt-[24px]">
                    <AlertDialogAction
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                        }}
                        disabled={isSubmitting}
                        className="w-full bg-destructive hover:bg-destructive/90 text-destructive-foreground rounded-[12px] py-[14px] text-[15px] h-auto"
                    >
                        {isSubmitting ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                {t('subsidiary:archivage')}
                            </>
                        ) : (
                            t('subsidiary:ouiArchiver')
                        )}
                    </AlertDialogAction>
                    <AlertDialogCancel
                        disabled={isSubmitting}
                        className="w-full bg-muted hover:bg-border text-foreground rounded-[12px] py-[14px] text-[15px] h-auto mt-0 border-0"
                    >
                        {t('subsidiary:annuler')}
                    </AlertDialogCancel>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
